import React from 'react';
import { Paper, Typography, Box, Grid, useTheme } from '@mui/material';
import { motion } from 'framer-motion';

const getColor = (change) => {
  if (change > 0) return 'success.main';
  if (change < 0) return 'error.main';
  return 'text.secondary';
};

const MetricCard = ({ icon, label, value, change }) => {
  const theme = useTheme();
  const isPositive = change > 0;
  const isNegative = change < 0;
  return (
    <motion.div
      whileHover={{ y: -4, boxShadow: theme.palette.mode === 'dark' ? '0 8px 32px #0008' : '0 8px 32px #0002' }}
      style={{ width: '100%' }}
    >
      <Paper
        elevation={3}
        sx={{
          p: 3,
          mb: 2,
          bgcolor: theme.palette.mode === 'dark' ? 'grey.900' : 'grey.50',
          color: theme.palette.mode === 'dark' ? 'grey.100' : 'grey.900',
          borderRadius: 3,
          minHeight: 120,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
        }}
      >
        <Box display="flex" alignItems="center" mb={1}>
          {icon && <Box mr={1}>{icon}</Box>}
          <Typography variant="body2" color="text.secondary">{label}</Typography>
        </Box>
        <Typography variant="h4" fontWeight={700} gutterBottom>{value}</Typography>
        <Typography variant="body2" sx={{ color: getColor(change) }}>
          {change > 0 ? '+' : ''}{change}%
        </Typography>
      </Paper>
    </motion.div>
  );
};

const MetricCards = ({ metrics }) => {
  return (
    <Grid container spacing={2} direction="column">
      {metrics.map((metric, idx) => (
        <Grid item key={idx}>
          <MetricCard {...metric} />
        </Grid>
      ))}
    </Grid>
  );
};

export default MetricCards; 